import { alpha } from '@mui/system';
import { themeObject as theme } from 'lib';

export const styles = {
    sdzIcon: {
        height: '36px',
        width: '36px',
        color: theme.palette.grayScale[600],
        borderRadius: '18px',
        opacity: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    currentSdz: {
        fontFamily: 'Red Hat Text',
        color: theme.palette.grayScale[600],
        marginTop: 'auto',
        fontSize: '1.2rem',
        fontWeight: 600,
        marginBottom: 'auto',
    },
    sdzOptionContainer: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
    },
    sdzOptionText: {
        margin: '5px 0 5px 10px',
        fontFamily: 'Red Hat Text',
        textTransform: 'Uppercase',
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: '26.46px',
        color: theme.palette.grayScale[800],
    },
    sdzHeading: {
        fontWeight: 600,
        fontSize: '28px',
        fontFamily: 'Raleway',
        lineHeight: '32.87px',
        color: theme.palette.primary[700],
        textAlign: 'center',
        padding: '0px 16px 8px 16px',
    },
    sdzHeadingtext: {
        ...theme.typography.body.default,
        ...theme.typography.body.body2,
        ...theme.typography.body.regular,
        lineHeight: '18.52px',
        color: theme.palette.grayScale[800],
        textAlign: 'center',
    },
    dzsMenuItem: {
        width: '800px',
    },
    sdzSelectorButton: {
        height: '40px',
        border: '1px solid',
        borderColor: theme.palette.grayScale[300] /* Grayscale/300 */,
        borderRadius: '4px',
        padding: '4.56px 8px 5.44px 5px',
    },
    sdzSelectorIcon: {
        height: '1.5rem',
        width: '1.5rem',
        color: theme.palette.primary[500],
    },
    sdzMenu: {
        '.MuiMenu-paper': {
            width: '317px',
            boxShadow: `0px 1px 18px 0px ${alpha(
                theme.palette.grayScale[700],
                0.12
            )},0px 6px 10px 0px ${alpha(
                theme.palette.grayScale[700],
                0.14
            )},0px 3px 5px -1px ${alpha(theme.palette.grayScale[700], 0.2)}`,
        },
        '& .sdz-heading': {
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
        },
        '.MuiMenu-list': {
            margin: '16px 0px',
            padding: '8px 0px',
        },
        '& .sdz-menuitem': {
            padding: '12px 18px',
        },
    },
    sdzSelectorMenuItem: {
        width: '100%',
        pl: 5,
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary[50], 0.45),
        },
        '& .MuiBox-root': {
            '& .MuiTypography-root': {
                fontSize: '16px',
                lineHeight: '24px',
            },
        },
    },
    sdzMenuItem: {
        width: '100%',
        p: '12px 18px',
        '&:hover': {
            backgroundColor: theme.palette.primary[50],
        },
    },
    sdzContainer: {
        boxShadow: `0px 1px 18px 0px ${alpha(
            theme.palette.grayScale[700],
            0.12
        )},0px 6px 10px 0px ${alpha(
            theme.palette.grayScale[700],
            0.14
        )},0px 3px 5px -1px ${alpha(theme.palette.grayScale[700], 0.2)}`,
        backgroundColor: theme.palette.background.default,
        borderRadius: '20px',
        padding: '77px 61px 147px 61px',
        textAlign: 'center',
    },
    sdzImage: {
        height: '95px',
        width: '398.75px',
        marginLeft: '24.12px',
        marginRight: '24.12px',
    },
    sdzHeadingDivider: {
        height: 0,
        borderWidth: '1px',
        borderColor: theme.palette.grayScale[200],
        m: '8px 12px',
    },
    sdzImageAndLogoutButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    sdzLogoutButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        mt: 5.5,
    },
    sdzSelectorOptionContainer: {
        mx: '81.5px',
    },
    sdzIconSelectFieldStyles: {
        height: '18px',
        width: '16.5px',
    },
    sdzSelectIconStyles: {
        height: '30px',
        width: '30px',
    },
    sdzHeaderContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        ml: '23.17px',
    },
    sdzHeaderTextStyles: {
        ...theme.typography.h3,
        lineHeight: '100%',
        color: theme.palette.grayScale[700],
    },
    sdzSubHeaderTextStyles: {
        ...theme.typography.captions.default,
        ...theme.typography.captions.regular,
        lineHeight: '100%',
        color: theme.palette.grayScale[700],
        mt: 2,
        mb: '12px',
    },
    sdzMenuItemPadding: {
        pl: '33.5px !important',
    },
    sdzMenuOptionStyles: {
        fontSize: '20px !important',
        lineHeight: '100% !important',
    },
};
